export default __webpack_public_path__ + "static/media/cutter.fd54c97d.svg";